import React from "react";

const TableRight = () => {
  return (
    <>
      <div className="container">
        <div className="flex">
          <div>
            <div className="flex mt-16">
              <img src="images/tabel5-two.svg" alt="Tabel" className="mr-7" />
              <img src="images/tabel3.svg" alt="Tabel" className="mr-7" />
              <img src="images/tabel2-two.svg" alt="Tabel" className="" />
            </div>
          </div>
          <div className="mt-28 ml-4">
            <img src="images/raketa-tabel.svg" alt="Tabel" />
          </div>
          <div className="ml-4 mt-28">
            <img src="images/TM1-tabel.svg" alt="Tabel" />
          </div>
        </div>
        <div className=" flex ">
          <div className="mr-30 mt-10">
            <div className="flex">
              <div>
                <img src="images/tabel9.svg" alt="Tabel" className="mb-8" />
                <img src="images/tabel10-two.svg" alt="Tabel" className="" />
              </div>
              <div className="ml-10">
                <div>
                  <img
                    src="images/tabel6.svg"
                    alt="Tabel"
                    className="mr-14 mb-3"
                  />
                  <img
                    src="images/tabel7-two.svg"
                    alt="Tabel"
                    className="mb-3"
                  />
                  <img
                    src="images/tabel8-two.svg"
                    alt="Tabel"
                    className="mb-3"
                  />
                  <img src="images/F-tabel.svg" alt="Tabel" className="" />
                </div>
              </div>
            </div>
            <div className="flex mt-20">
              <img src="images/tabel11-two.svg" alt="Tabel" className="mr-7" />
              <img src="images/tabel3.svg" alt="Tabel" className="mr-7" />
              <img src="images/tabel14-two.svg" alt="Tabel" className="" />
            </div>
          </div>

          <div className="">
            <img src="images/reztabel-one.svg" alt="Tabel" className="mb-1 " />
            <img
              src="images/K432-tabel.svg"
              alt="Tabel"
              className="mb-1 ml-1"
            />
            <img src="images/reztabel-two.svg" alt="Tabel" className="mb-2" />
            <img src="images/TM3-tabel.svg" alt="Tabel" className="mb-4" />
            <img src="images/tabel16-two.svg" alt="Tabel" className="ml-8" />
          </div>
          <div className="">
            <img src="images/BAR-tabel.svg" alt="Tabel" className="mb-1 " />
          </div>
        </div>
      </div>
    </>
  );
};

export default TableRight;
